import { render, staticRenderFns } from "./DownArrow.vue?vue&type=template&id=194e2e40"
import script from "./DownArrow.vue?vue&type=script&lang=js"
export * from "./DownArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports